import { render, staticRenderFns } from "./ClipboardDrawer.vue?vue&type=template&id=11f52244&scoped=true"
import script from "./ClipboardDrawer.vue?vue&type=script&lang=js"
export * from "./ClipboardDrawer.vue?vue&type=script&lang=js"
import style0 from "./ClipboardDrawer.vue?vue&type=style&index=0&id=11f52244&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f52244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f52244')) {
      api.createRecord('11f52244', component.options)
    } else {
      api.reload('11f52244', component.options)
    }
    module.hot.accept("./ClipboardDrawer.vue?vue&type=template&id=11f52244&scoped=true", function () {
      api.rerender('11f52244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/clipboard/ClipboardDrawer.vue"
export default component.exports